import { columns } from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/payment'
export const namespace = 'payment'
export const clientRoute = '/purchase/payment'
export const dependencies = ['purchase', 'paymentMethod']
export const params = {
  include: 'purchase,paymentMethod'
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'amount'
const subtitleColumn = 'date'
const infoColumns = ['description']
/* --------------------------- */

const state = {
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  titleColumn,
  subtitleColumn,
  infoColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
